import { resolveBackTarget } from '@/utils/helpers'

export default [
  {
    path: '/collections',
    components: {
      default: () => import('@/views/Collections/Collections.vue'),
      appbar: () => import('@/views/Bookmarks/components/BookmarkAppBar.vue'),
      footer: () => import('@/components/AppFooterExpandable.vue'),
    },
    props: {
      footer: {
        expandable: true,
      },
    },
    meta: {
      appbarVisibility: true,
      requiresAuth: true,
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  // Pin collection
  {
    path: '/collections/:collectionId/pin',
    component: () => import('@/views/CollectionItems/EditPinPosition.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  // Create
  {
    path: '/collections/add',
    component: () => import('@/views/Collections/CreateCollection.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  // View bookmarks, order matters
  {
    path: '/collections/:id',
    components: {
      default: () => import('@/views/Collections/Collection.vue'),
      sidebar: () => import('@/views/Collections/components/CollectionSidebar.vue'),
      appbar: () => import('@/views/Collections/components/CollectionAppBar.vue'),
      footer: () => import('@/components/AppFooterExpandable.vue'),
    },
    props: {
      footer: {
        expandable: true,
      },
    },
    meta: {
      sidebarVisibility() {
        return true
      },
      appbarVisibility: true,
      requiresAuth: true,
      transition: 't-fade',
      layoutTransition: 't-expand',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  // Edit
  {
    path: '/collections/:id/edit',
    component: () => import('@/views/Collections/EditCollection.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      layoutProps: {
        backButton: {
          // invite pages redirect to this, we don't want to use regular back button
          to: from => `/collections/${from.params.id}`,
        },
      },
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  {
    path: '/collections/:id/access',
    component: () => import('@/views/Collections/SubCollectionUserAccess.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      layoutProps: {
        backButton: {
          to: route => resolveBackTarget(route, `/collections/${route.params.id}`),
        },
      },
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  {
    path: '/collections/:id/add-sub-collection',
    component: () => import('@/views/Collections/CreateSubCollection.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      layoutProps: {
        backButton: {
          // invite pages redirect to this, we don't want to use regular back button
          to: from => `/collections/${from.params.id}`,
        },
      },
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  {
    path: '/collections/:id/members',
    component: () => import('@/views/Collections/ManageMembers.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      layoutProps: {
        backButton: {
          to: route => resolveBackTarget(route, `/collections/${route.params.id}`),
        },
      },
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  {
    path: '/collections/:id/members/:memberId/edit',
    component: () => import('@/views/Collections/EditMemberRole.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      layoutProps: {
        backButton: {
          to: route => resolveBackTarget(route, `/collections/${route.params.id}/members`),
        },
      },
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  {
    path: '/collections/bulk/edit-share-link',
    component: () => import('@/views/Collections/BulkEditShareLink.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  {
    path: '/collections/:id/edit-share-link',
    component: () => import('@/views/Collections/EditShareLink.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  {
    path: '/collections/bulk/invite',
    component: () => import('@/views/Collections/BulkInviteMembers.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  {
    path: '/collections/:id/invite',
    component: () => import('@/views/Collections/InviteMembers.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  // Join
  {
    path: '/collections/:id/invite-link/:token',
    component: () => import('@/views/Collections/ShareLinkJoin.vue'),
    meta: {
      requiresAuth: true,
      layout: 'fullscreen',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  {
    path: '/collections/:id/invite-email/:token',
    component: () => import('@/views/Collections/InviteAccept.vue'),
    meta: {
      requiresAuth: true,
      layout: 'fullscreen',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  // Pin item in collection
  {
    path: '/collections/:id/items/:itemId/pin',
    component: () => import('@/views/CollectionItems/EditPinPosition.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  // bookmarks
  {
    path: '/collections/:id/bookmarks/:bookmarkId',
    component: () => import('@/views/Bookmarks/BookmarkDetail.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus-detail',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
      layoutProps: {
        backButton: {
          to: from => `/collections/${from.params.id}`,
        },
      },
    },
  },
  {
    path: '/collections/:id/bookmarks/:bookmarkId/comments',
    redirect: to => `/collections/${to.params.id}/bookmarks/${to.params.bookmarkId}`,
  },
  {
    path: '/collections/:id/bulk/add-tags',
    component: () => import('@/views/Bookmarks/BulkEditTags.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  {
    path: '/collections/:id/bulk/remove-tags',
    component: () => import('@/views/Bookmarks/BulkRemoveTags.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  {
    path: '/collections/:id/bookmarks/:bookmarkId/likes',
    component: () => import('@/views/CollectionItems/ItemLikes.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
      layoutProps: {
        backButton: {
          to: route => resolveBackTarget(
            route,
            `/collections/${route.params.id}/bookmarks/${route.params.bookmarkId}`,
          ),
        },
      },
    },
  },
  {
    path: '/collections/:id/notes/:noteId/likes',
    component: () => import('@/views/CollectionItems/ItemLikes.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
      layoutProps: {
        backButton: {
          to: route => resolveBackTarget(
            route,
            `/collections/${route.params.id}/notes/${route.params.noteId}`,
          ),
        },
      },
    },
  },
  {
    path: '/collections/:id/bookmarks/:bookmarkId/tags',
    component: () => import('@/views/Bookmarks/EditTags.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
      layoutProps: {
        backButton: {
          to: route => resolveBackTarget(
            route,
            `/collections/${route.params.id}/bookmarks/${route.params.bookmarkId}`,
          ),
        },
      },
    },
  },
  {
    path: '/collections/:id/notes/:noteId/tags',
    component: () => import('@/views/Bookmarks/EditTags.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
      layoutProps: {
        backButton: {
          to: route => resolveBackTarget(
            route,
            `/collections/${route.params.id}/notes/${route.params.noteId}`,
          ),
        },
      },
    },
  },
  {
    path: '/collections/:id/bookmarks/:bookmarkId/edit',
    component: () => import('@/views/Bookmarks/Edit.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
      layoutProps: {
        backButton: {
          to: from => `/collections/${from.params.id}/bookmarks/${from.params.bookmarkId}`,
        },
      },
    },
  },
  // notes
  {
    path: '/collections/:id/notes/:noteId',
    component: () => import('@/views/Notes/NoteDetail.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus-detail',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
      layoutProps: {
        backButton: {
          to: from => `/collections/${from.params.id}`,
        },
      },
    },
  },
  {
    path: '/collections/:id/notes/:noteId/edit',
    component: () => import('@/views/Notes/EditNote.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  // INFO: param naming is like this cause it is shared with the bookmark route
  {
    path: '/collections/:collectionId/notes/:id/add-collections',
    component: () => import('@/views/CollectionItems/AddToCollections.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  // INFO: param naming is like this cause it is shared with the bookmark route
  {
    path: '/collections/:collectionId/bookmarks/:id/add-collections',
    component: () => import('@/views/CollectionItems/AddToCollections.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  {
    path: '/collections/:collectionId/bulk/add-collections',
    component: () => import('@/views/Bookmarks/BulkAddToCollections.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
]
